// extracted by extract-css-chunks-webpack-plugin
module.exports = {"resultChartWrapper":"_2ksbCl"};